import React, { Component } from "react";
import { Grid } from "react-bootstrap";

class Footer extends Component {
  render() {
    return <React.Fragment></React.Fragment>;
    return (
      <footer className="footer">
        <Grid>
          <nav className="pull-left">
            <ul>
              <li>
                <a
                  data-gtm-type="click"
                  data-gtm-clicktype="link"
                  data-gtm-name="suporte"
                  href="/#/suport"
                >
                  Suporte
                </a>
              </li>
            </ul>
          </nav>
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            <a
              data-gtm-type="click"
              data-gtm-clicktype="link"
              data-gtm-name="Pluz"
              href=""
            >
              Pluz
            </a>
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx